export default "__VITE_ASSET__Cp328va1__"